<div class="loader-overlay" *ngIf="isVisible">
  <div class="loader-content">
    <!-- Logo de La Joya arriba -->
    <div class="loader-logo">
      <img [src]="getImageUrl('logos/variations/la_Joya_footer.png')" alt="La Joya Park Resort" class="logo">
    </div>
    
    <!-- Animación Lottie -->
    <div class="loader-animation">
      <img [src]="getImageUrl('animations/loader.gif')" alt="Cargando..." class="loader-gif">
    </div>
    
    <!-- Texto de carga -->
    <div class="loader-text">
      <h3>Cargando tu experiencia</h3>
    </div>
  </div>
</div>
